import { History } from 'history';
import * as React from 'react';
import { HistoryRouterProps, Route, Routes, unstable_HistoryRouter as HistoryRouter, useLocation } from 'react-router';

import { Layout } from './components/Layout';
import { Audits } from './containers/Audits';
import { AuditsAll } from './containers/AuditsAll';
import { AuditsCurrent } from './containers/AuditsCurrent';
import { AuditsFailed } from './containers/AuditsFailed';
import DeviceDetail from './containers/DeviceDetail';
import Devices from './containers/Devices';
import { Emails } from './containers/Emails';
import Home from './containers/Home';
import Jobs from './containers/Jobs';
import { LiteOrgsReport } from './containers/LiteOrgsReport';
import { OrgDetail } from './containers/OrgDetail';
import Orgs from './containers/Orgs';
import Reports from './containers/Reports';
import { Users } from './containers/Users';
import { AuthInterop } from './containers/AuthInterop';
import { withRouter } from './utils/withRouter';

// Pages still get the react-router 5 route props (match, location, history) that <Route component> passed them.
const pages = (
  [
    ['/', Home],
    ['/devices', Devices],
    ['/devices/:id', DeviceDetail],
    ['/orgs', Orgs],
    ['/orgs/:id', OrgDetail],
    ['/users', Users],
    ['/reports', Reports],
    ['/reports/lite-orgs', LiteOrgsReport],
    ['/audits', Audits],
    ['/audits/all', AuditsAll],
    ['/audits/current', AuditsCurrent],
    ['/audits/failed', AuditsFailed],
    ['/emails', Emails],
    ['/jobs', Jobs],
    ['/authinterop', AuthInterop],
  ] as [string, React.ComponentType<any>][]
).map(([path, component]) => ({ path, Page: withRouter(component) }));

// Layout reads window.location (nav, title, login gate), so it has to re-render on every navigation.
const AppLayout = () => {
  useLocation();
  return (
    <Layout>
      <Routes>
        {pages.map(({ path, Page }) => (
          <Route key={path} path={path} element={<Page />} />
        ))}
      </Routes>
    </Layout>
  );
};

// HistoryRouter instead of BrowserRouter because services/Auth navigates outside React through `history`. history 5
// lacks the optional createURL/encodeLocation of react-router's own History type, hence the cast. No transitions, so
// navigation renders synchronously as it did with react-router 5.
const Root = ({ history, basename }: { history: History; basename: string }) => (
  <HistoryRouter
    history={history as unknown as HistoryRouterProps['history']}
    basename={basename}
    useTransitions={false}
  >
    <AppLayout />
  </HistoryRouter>
);

export default Root;
